import classNames from 'classnames';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

import { useOpen } from 'hooks/use-open';

import type { MarkContext } from '../mark-panel.types';

export interface MarkContextChipProps {
  context: MarkContext;
}

const MarkContextChip = ({ context }: MarkContextChipProps) => {
  const { isOpen, handleToggle } = useOpen(false);
  const { summary } = context;

  if (!summary) {
    return (
      <div className="w-80">
        <div
          className="flex w-full min-w-0 items-center rounded-md border border-navy-100 bg-white px-3 py-1.5 text-sm font-semibold text-navy-600"
          title={context.label}
        >
          <span className="min-w-0 truncate">{context.label}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-80 flex-col gap-1.5">
      <Button
        variant="reserve-outlined"
        size="sm"
        className={classNames('w-full min-w-0 justify-between', {
          'border-navy-100 text-navy-600': !isOpen,
          'border-navy-800 text-navy-800 shadow': isOpen,
        })}
        iconAfter={
          <Icons.ChevronDown
            className={classNames('size-3.5 transition-transform', {
              'rotate-180': isOpen,
            })}
            aria-hidden="true"
          />
        }
        onClick={handleToggle}
        aria-expanded={isOpen}
        title={context.label}
      >
        <span className="min-w-0 truncate">{context.label}</span>
      </Button>

      {isOpen && (
        <div className="flex flex-col gap-1.5 rounded-md bg-gray-50 p-3">
          <p className="break-words text-sm font-semibold text-gray-700">
            {summary.title}
          </p>

          <dl className="flex flex-col gap-1.5">
            {summary.rows.map((row) => (
              <div
                key={row.label}
                className="flex items-start justify-between gap-2"
              >
                <dt className="shrink-0 text-xs text-gray-500">{row.label}</dt>
                <dd className="min-w-0 break-words text-right text-xs font-semibold text-gray-700">
                  {row.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </div>
  );
};

export default MarkContextChip;
